import CommodityName from '../commodities/CommodityName';

const columns = [
    { accessorKey: 'name', header: () => <span className="settings-lookup__commodity-name"><span className="settings-lookup__commodity-icon-slot" aria-hidden="true" /><span>Name</span></span>,
        meta: { sortBy: 'Name', relatedFields: ['commodityId'] },
        cell: ({ row }) => <span title={row.original.commodity?.name}><CommodityName commodity={{ ...row.original.commodity, name: row.original.name,
            commodityIcon: row.original.commodity?.commodityIcon || row.original.commodity?.name,
            abbreviation: row.original.commodity?.abbreviation }} /></span> },
    { accessorKey: 'abbreviation', header: 'Abbreviation', meta: { sortBy: 'Abbreviation' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'dimensionName', header: 'Dimension', enableSorting: false, meta: { relatedFields: ['dimensionId'] }, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'baseUoMName', header: 'Base UOM', enableSorting: false, meta: { relatedFields: ['baseUoMId'] }, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'baseUoMConversion', header: 'Base UOM Conversion', meta: { sortBy: 'BaseUoMConversion' }, cell: ({ getValue }) => getValue() ?? '—' },
];

export default columns;
